export const FeatureFlags = {
  EARNINGS_BENCHMARKS: 'earnings-benchmarks',
  AGREEMENTS_SERVER_SIDE_ENABLED: 'agreements-server-side-enabled',
  TUM_REDIRECT_ENABLED: 'tum-redirect-enabled',
  AGREEMENTS_ACADEMIC_YEAR_ENABLED: 'agreements-academic-year-enabled',
  ADD_ADDITIONAL_AGREEMENT_PAYMENT_ENABLED: 'add-additional-agreement-payment-enabled',
  MULTIPLE_PAYMENT_TYPES: 'multiple-payment-types',
  AGREEMENT_LINK_MULTIPLE_BUDGETS_ENABLED: 'agreement-link-multiple-budgets-enabled',
  SCHOLARSHIP_AGREEMENTS_ENABLED: 'scholarship-agreements-enabled',
  AGREEMENT_CSV_UPLOAD_ENABLED: 'agreement-csv-upload-enabled',
  AGENTS_ENABLED: 'agents-enabled',
  CONTRACT_REDLINING_ENABLED: 'contract-redlining',
  PAYMENT_CHANGE_ACTIVITY_DRAWER_ENABLED: 'payment-change-activity-drawer-enabled',
  AGENTS_TYPE_ENABLED: 'agents-type-enabled',
} as const;

export type FeatureFlag = keyof typeof FeatureFlags;
